<template>
  <div style="width: 100%;">
    <div v-if="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">{{ $t("page.general.cargar") }}</span>
        </div>
      </div>
    </div>

    <div v-if="!loading" class="row my-5">
      <div
        class="card"
        v-for="(tipo_bloque, index) in tiposBloque"
        :key="'tipo_bloque' + index"
        style="width: 100%;"
        :ref="`parentDiv-${index}`"
        :id="`miDiv-${index}`"
      >
        <div>
          <div
            class="card-header mt-3"
            v-bind:id="tipo_bloque.id_tipo_bloque"
            :style="{ 'background-color': cia.color_fondo_header }"
          >
            <h4 class="mb-0 text-center" :style="{ color: cia.color_texto_header }">
              {{ tipo_bloque.nombre_tipo_bloque }}
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div
                class="col-lg-3 col-md-6"
                v-for="(bloque, index2) in visibleBloques[index]"
                :key="'tipo_bloque' + index + index2"
              >
                <bloqueCardEcommerce
                  @modal-opened="openModal"
                  :bloque="bloque"
                />
                <b-popover :target="'popover-target-' + bloque.id_bloque" triggers="hover" placement="right">
                  <template #title>{{bloque.nombre_bloque}}</template>
                  <div>
                    {{bloque.descripcion}}
                    <ul class="ml-4">
                      <li
                        v-for="(tema,index2) in bloque.temas"
                      >
                        {{tema.nombre}}
                      </li>
                    </ul>
                  </div>
                  <div>
                    <b-button
                      class="text-uppercase"
                      block
                      @click="irADetalle(bloque)"
                    >
                      {{ $t("page.ecommerce.inicio.ver_detalle") }}
                    </b-button>

                    <b-button
                      v-if="bloque.comprado != '1'"
                      class="text-uppercase"
                      :class="{ 'blocked-pointer': isBloqueLleno(bloque) }"
                      block
                      :variant="isBloqueLleno(bloque) ? 'danger' : 'success'"
                      @click="handleComprarBloque(bloque)"
                    >
                      {{
                        isBloqueLleno(bloque)
                          ? $t("page.ecommerce.inicio.no_disponible")
                          : $t("page.ecommerce.inicio.comprar")
                      }}
                    </b-button>

                    <b-button
                      v-else
                      class="text-uppercase btn-color"
                      block
                      @click="verContenido(bloque)"
                    >
                      {{ $t("page.ecommerce.inicio.ver_contenido") }}
                    </b-button>
                  </div>
                </b-popover>
              </div>
            </div>

            <div v-if="tipo_bloque.bloques.length > visibleBloques[index].length" class="text-center mt-3">
              <button @click="mostrarMas(index)" class="btn btn-primary">
                {{ $t("page.ecommerce.inicio.mostrar_mas") }}
              </button>
            </div>
            <div
              v-if="(tipo_bloque.bloques.length == visibleBloques[index].length) && tipo_bloque.bloques.length > 4"
              class="text-center mt-3"
            >
              <button @click="mostrarMenos(index)" class="btn btn-primary">
                {{ $t("page.ecommerce.inicio.mostrar_menos") }}
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div
      class="card"
      :key="'tema' + index"
      style="width: 100%;"
      :ref="`parentDivTema`"
      :id="`miDivTema`"
    >
      <div
        class="card-header mt-3"
        style="width: 100%;"
        :style="{ 'background-color': cia.color_fondo_header }"
      >
        <h4 class="mb-0 text-center" :style="{ color: cia.color_texto_header }">
          CAPACITACIÓN
        </h4>
      </div>
    </div>

    <div class="row d-flex w-100 justify-content-center">
      <b-button @click="filtrar('todos')" variant="success">{{ $t("page.general.todos") }} {{ filtro == 'todos' ? `(${temas.length})` : ''}}</b-button>
      <b-button @click="filtrar('virtual')" class="ml-3 mr-3" variant="success">{{ $t("page.general.virtual") }} {{ filtro == 'virtual' ? `(${temas.length})` : ''}}</b-button>
      <b-button @click="filtrar('presencial')" variant="success">{{ $t("page.general.presencial") }} {{ filtro == 'presencial' ? `(${temas.length})` : ''}}</b-button>
      <b-button @click="filtrar('mixto')" class="ml-3 mr-3" variant="success">STREAMING  {{ filtro == 'mixto' ? `(${temas.length})` : ''}}</b-button>
    </div>


    <div v-if="loadingTemas">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">{{ $t("page.general.cargar") }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <form class="col-3" v-on:submit.prevent="buscarFn">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="buscar">
              {{ $t("page.consulta_plan_capacitacion.buscar_search") }}
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="buscar"
            placeholder=""
            aria-label=""
            aria-describedby="buscar"
          />
          <div class="input-group-append" v-if="buscar">
            <button type="button" class="btn btn-outline-secondary" @click="buscar = ''">
              <b-icon icon="x-circle" variant="danger"></b-icon>
            </button>
          </div>
        </div>
      </form>

    </div>

    <div
      style="width: 100%;"
      v-if="!loadingTemas && temas.length > 0"
      class=" my-5"
    >


      <div class="card-body">
        <div class="row">
          <div
            class="col-lg-3 col-md-6"
            v-for="(tema, index2) in visibleTemas"
            :key="'tema' + index2"
          >
            <cursoCardEcommerce
              @modal-opened="openModal"
              :tema="tema"
              :yaComprado="getTemaComprado(tema).comprado"
            />
            <b-popover
              :target="'popover-target-' + `${tema.modalidad == 'Virtual' ? tema.cve_tema : tema.cve_curso }`"
              triggers="hover"
              placement="right"
            >
              <template #title>{{ `${tema.modalidad == 'Virtual' ? tema.cve_tema : tema.cve_curso }` }} - {{tema.nombre_tema}}</template>
              <div>
                {{tema.descripcion_tema}}
              </div>
              <div v-if="getTemaComprado(tema).comprado" class="alert-streaming-info">
                <span class="alert-icon">⚠️</span>
                <div>
                  <strong>Nota importante:</strong><br>
                  No puedes adquirir este curso porque ya tienes otro curso activo o pendiente del mismo tema en la fecha
                  {{ getTemaComprado(tema).item.fecha_curso }}.
                </div>
              </div>
              <div>
                <b-button
                  class="text-uppercase"
                  block
                  @click="irADetalle(tema)"
                >
                  {{ $t("page.ecommerce.inicio.ver_detalle") }}
                </b-button>

                <b-button
                  v-if="tema.comprado != '1'"
                  class="text-uppercase"
                  :class="{ 'blocked-pointer': isTemaLleno(tema) }"
                  block
                  :variant="isTemaLleno(tema) ? 'danger' : 'success'"
                  @click="handleComprarTema(tema)"
                >
                  {{ isTemaLleno(tema)
                    ? $t("page.ecommerce.inicio.no_disponible")
                    : $t("page.ecommerce.inicio.comprar")
                  }}
                </b-button>

                <b-button
                  v-else
                  class="text-uppercase btn-color"
                  block
                  @click="verContenido(null, tema)"
                >
                  {{ $t("page.ecommerce.inicio.ver_contenido") }}
                </b-button>
              </div>
            </b-popover>
          </div>
        </div>

        <div v-if="temas.length > visibleTemas.length" class="text-center mt-3">
          <button @click="mostrarMasTemas(index2)" class="btn btn-primary">
            {{ $t("page.ecommerce.inicio.mostrar_mas") }}
          </button>
        </div>
        <div
          v-if="(temas.length == visibleTemas.length) && temas.length > 4"
          class="text-center mt-3"
        >
          <button @click="mostrarMenosTemas(index2)" class="btn btn-primary">
            {{ $t("page.ecommerce.inicio.mostrar_menos") }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="!loadingTemas && temas.length == 0" class="d-flex justify-content-center p-5 text-uppercase font-weight-bold">
      <strong >
        No hay resultados
      </strong>
    </div>



    <div
      class="modal fade"
      id="modalTemas"
      role="dialog"
      aria-labelledby="Temas"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Temas
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div
                  v-for="(tema, index) in bloqueSelected.temas"
                  :key="index"
                  class="col-md-4 mb-4"
                >
                  <cursoCardEcommerce :tema="tema" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalCesta"
      role="dialog"
      aria-labelledby="Temas"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              {{ $t("page.ecommerce.inicio.contenidos_seleccionados") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div v-for="(item,index) in itemsTemp" class="order-detail-row">
                <img
                  v-if="!!item.imagen || item.imagen == ''"
                  :src="item.imagen"
                  alt="item-image"
                  width="10%"
                >
                <div
                  v-else
                  class="no-image"
                >
                  Sin imagen
                </div>
                <div class="name-container">
                  <span class="name-label">{{ item.nombre }}</span>

                  <div class="rating-container">
                    <star-rating
                      read-only="true"
                      :rating="item.rating"
                      :show-rating="false"
                      star-size="15"
                      border-color="#FF0"
                      increment="0.5"
                    />
                    <span class="text-muted ml-2">{{item.rating}}/5</span>
                  </div>
                </div>
                <b-button @click="deleteItemById(item.id)" variant="link">
                  {{ $t("page.general.eliminar") }}
                </b-button>
                <span>${{ item.precio }} MXN</span>
              </div>
              <div class="total-container">
                <h4>Total: </h4> <span>{{ totalAmount }} MXN</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cerrarModalCesta">
              {{ $t("page.ecommerce.inicio.seguir_comprando") }}
            </button>
            <button type="button" class="btn btn-primary" @click="goToShoppingCart">
              {{ $t("page.ecommerce.inicio.ir_a_pagar") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CursoCardEcommerce from "./curso_card_ecommerce";
import BloqueCardEcommerce from "./bloque_card_ecommerce";
import ShoppingCart from "./shopping_cart/shopping_cart";
import { mapActions, mapGetters } from 'vuex';
import StarRating from 'vue-star-rating'


export default {
  components: {
    cursoCardEcommerce: CursoCardEcommerce,
    bloqueCardEcommerce: BloqueCardEcommerce,
    shoppingCart: ShoppingCart,
    StarRating,
  },
  data() {
    return {
      loading: true,
      loadingTemas: true,
      tiposBloque: [],
      bloqueSelected: {},
      items: [],
      visibleBloques: [],
      visibleTemas: [],
      temas: [],
      temasOriginal: [],
      bloqueAgregado: {},
      itemsTemp: [],
      totalAmount: 0,
      imagenNoticia: '',
      cargandoTemas: true,
      temasFiltrados: [],
      filtro: '',
      buscar: '',
      temasOriginal: [],
    };
  },
  methods: {
    isBloqueLleno(bloque) {
      return +bloque.capacidad_asistencia != 0 && (+bloque.total_asistentes == +bloque.capacidad_asistencia);
    },
    isTemaLleno(tema) {
      return +tema.total_asistentes == +tema.capacidad_asistencia;
    },
    handleComprarBloque(bloque) {
      if (this.isBloqueLleno(bloque)) {
        return;
      }
      this.abrirModalCesta(bloque);
    },
    handleComprarTema(tema) {
      if (this.isTemaLleno(tema) || this.getTemaComprado(tema).comprado) {
        return;
      }
      this.abrirModalCesta(null, tema);
    },
    buscarFn() {
      this.temas = [...this.temasOriginal];

      this.temas = this.temas.filter(tema =>
        tema.nombre_tema.toLowerCase().includes(this.buscar.toLowerCase())
      );

      // Controlar la cantidad de elementos visibles
      this.visibleTemas = this.temas.length > 4 ? this.temas.slice(0, 4) : this.temas;
    },
    filtrar(filtro) {
      this.filtro = filtro;
      this.getTemasInicio(filtro)
    },
    verContenido(bloque, tema) {
      this.$router.push({
        name: "Consultar_Plan_Capacitacion",
        params: {
          bloques: !!bloque,
          bloque,
        }
      });
    },
    deleteItemById(itemId) {
      this.deleteItem(itemId);
      this.itemsTemp = this.itemsTemp.filter(item => item.id !== itemId);
      if (this.itemsTemp.length === 0) {
        this.cerrarModalCesta();
      }
      this.totalAmount = this.getTotalAmount();
    },
    cerrarModalCesta() {
      $(`#${'modalCesta'}`).modal('hide');
    },
    abrirModalCesta(bloque, tema) {

      if (!!bloque) {
        this.bloqueAgregado = bloque

        this.addItem({
          id: `bloque-${bloque.id_bloque}`,
          imagen: bloque.imagen_url,
          nombre: bloque.nombre_bloque,
          precio: bloque.precio,
          temas: bloque.temas,
          rating: bloque.rating,
          modalidad: bloque.modalidad,
        }).then(() => {
          this.itemsTemp = this.getCart().reverse();
          this.totalAmount = this.getTotalAmount();
          $(`#${'modalCesta'}`).modal();
        }).catch((error) => {
          toastr.error(error.message || 'Error al agregar al carrito');
        });
      } else {

        if (this.isTemaLleno(tema) || this.getTemaComprado(tema).comprado) {
          return;
        }

        // Validar si ya hay un curso del mismo tema en el carrito
        const carrito = this.getCart();
        if (tema.cve_tema != null && tema.cve_tema !== '' && carrito && carrito.length > 0) {
          const cursoMismoTema = carrito.find(i => {
            // Si es un bloque, no aplicamos la restricción
            if (i.id && i.id.startsWith('bloque-')) {
              return false;
            }
            // Solo comparar si ambos tienen cve_tema válido
            if (i.cve_tema != null && i.cve_tema !== '' && tema.cve_tema != null && tema.cve_tema !== '') {
              const temaCarrito = String(i.cve_tema).trim();
              const temaNuevo = String(tema.cve_tema).trim();
            // Solo retornar true si son exactamente iguales
            if (temaCarrito === temaNuevo) {
              return true;
            }
            }
            return false;
          });

          if (cursoMismoTema) {
            swal({
              title: "No se puede agregar",
              text: "Solo puedes agregar un curso del mismo tema al carrito",
              icon: "warning",
              button: "Aceptar"
            });
            return;
          }
        }

        this.addItem({
          id: `tema-${!!tema.cve_curso ? tema.cve_curso : tema.cve_tema}`,
          cve_curso: tema.cve_curso,
          cve_tema: tema.cve_tema,
          imagen: tema.imagen_url,
          nombre: tema.nombre_tema,
          precio: tema.precio,
          temas: tema.temas,
          rating: tema.rating,
          modalidad: tema.modalidad,
        }).then(() => {
          this.itemsTemp = this.getCart().reverse();
          this.totalAmount = this.getTotalAmount();
          $(`#${'modalCesta'}`).modal();
        }).catch((error) => {
          toastr.error(error.message || 'Error al agregar al carrito');
        });
      }
    },
    mostrarMas(index) {
      const currentLength = this.visibleBloques[index].length;
      const additionalBloques = this.tiposBloque[index].bloques.slice(currentLength, currentLength + 4);
      this.visibleBloques[index].splice(currentLength, 0, ...additionalBloques);
    },
    mostrarMasTemas(index) {
      const nuevosTemas = this.temas.slice(this.visibleTemas.length, this.visibleTemas.length + 4);
      this.visibleTemas = this.visibleTemas.concat(nuevosTemas);
    },
    mostrarMenos(index) {
      this.$set(this.visibleBloques, index, this.visibleBloques[index].slice(0, 4));
      const div = document.querySelector(`#miDiv-${index}`);
      const rect = div.getBoundingClientRect();

      window.scrollTo({
        top: window.scrollY + rect.top - 100,
        behavior: 'smooth'
      });
    },
    mostrarMenosTemas(index) {
      if (this.visibleTemas.length > 4) {
        this.visibleTemas = this.temas.slice(0, 4);
      }
    },
    irADetalle(item) {
      this.$router.push({
        name: "Detalle_Bloque",
        params: {
          item,
          yaComprado: this.getTemaComprado(item).comprado,
        }
      });
    },
    goToShoppingCart() {
      this.cerrarModalCesta();
      this.$router.push({
        name: "checkout",
      });
    },
    openModal(bloque) {
      this.bloqueSelected = bloque;
      $(`#${'modalTemas'}`).modal();
    },
    getCursosPorBloquesInicio() {
      this.$http.get(`e-commerce/inicio/${this.usuario.cve_empleado}`)
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.loading = false;
          this.tiposBloque = respuestaJson;

          this.tiposBloque.forEach(tipo => {
            tipo.bloques.forEach(bloque => {
              const temas = bloque.temas;

              if (temas.every(tema => tema.modalidad === "E_LEARNING")) {
                bloque.modalidad = "Virtual";
              } else if (temas.every(tema => tema.modalidad === "PRESENCIAL")) {
                bloque.modalidad = "Presencial";
              } else {
                bloque.modalidad = "Mixto";
              }
            });
          });

          this.visibleBloques = this.tiposBloque.map(tipo => tipo.bloques.slice(0, 4));
        })
        .catch((error) => {
          toastr.error(this.$t('page.ecommerce.inicio.error_inicio'));
          this.loading = false;
        });
    },
    getTemasInicio(filtro) {
      this.loadingTemas = true;
      this.$http.get(`e-commerce/temas/${this.usuario.cve_empleado}/${filtro}`)
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.loadingTemas = false;
          let cursosFiltrados = [];
          this.visibleTemas = [];
          this.temas = [];

          if (filtro == 'todos') {
            console.log('DEBUG: respuestaJson', respuestaJson);
            const hoy = moment();
            cursosFiltrados = [...respuestaJson.result, ...respuestaJson.virtual]

          } else if (filtro == 'virtual') {
            cursosFiltrados = respuestaJson.virtual
          } else if (filtro == 'mixto') {
            cursosFiltrados = respuestaJson.result
          } else if (filtro == 'presencial') {
            cursosFiltrados = respuestaJson.result
          }

          this.visibleTemas = cursosFiltrados.slice(0, 4);
          this.temas = cursosFiltrados;
          this.temasOriginal = cursosFiltrados;

          this.cargandoTemas = false;
        })
        .catch((error) => {
          toastr.error(this.$t('page.ecommerce.inicio.error_inicio'));
          this.cargandoTemas = false;
          this.loadingTemas = false;
        });
    },
    getTemaComprado(tema) {
      const ahora = new Date();
      const hoyStr = ahora.toISOString().split('T')[0]; // 'YYYY-MM-DD'

      // Si el curso ya está comprado, no bloqueamos nada
      if (tema.comprado === "1") {
        return { comprado: false, item: null };
      }

      for (const item of this.temasOriginal) {
        if (item.cve_tema !== tema.cve_tema || item.comprado !== "1") {
          continue;
        }

        const fechaCurso = new Date(item.fecha_curso);
        const fechaCursoStr = item.fecha_curso;
        const esMismoDia = fechaCursoStr === hoyStr;
        const cursoEsFuturo = fechaCurso > ahora;
        const cursoEsPasado = fechaCurso < ahora && !esMismoDia;
        const asistio = item.asistido === "1";
        const noAsistio = !item.asistido || item.asistido === "0";

        // 🚫 Regla 1: curso actual o futuro sin asistir → bloquear
        if ((esMismoDia || cursoEsFuturo) && !asistio) {
          return { comprado: true, item };
        }

        // ✅ Regla 2: curso pasado sin asistencia → permitir
        if (cursoEsPasado && noAsistio) {
          continue;
        }

        // ✅ Regla 3: curso actual o futuro pero ya asistió → permitir
        if ((esMismoDia || cursoEsFuturo) && asistio) {
          continue;
        }

        // Por defecto: bloquear
        return { comprado: true, item };
      }

      return { comprado: false, item: null };
    },
    ...mapActions(['addItem', "Actualizar_Help_Button", 'deleteItem']),
    ...mapGetters(['getCart', 'getTotalAmount']),
  },
  created() {
    this.menu.opcion.name = "Dashboard";
    this.menu.opcion.mostrar_name = false;
    this.menu.opcion.origin1.name = "";
    this.menu.opcion.origin1.route = "";
    this.menu.opcion.origin2.name = "";
    this.menu.opcion.origin2.route = "";
    this.menu.buttons.help.mostrar = false;
    this.menu.buttons.consultar = false;
    this.menu.buttons.excel = false;
    this.menu.buttons.nuevo = false;
  },
  mounted() {
    this.getCursosPorBloquesInicio();
    this.getTemasInicio('todos');
    this.filtro = 'todos';
    this.Actualizar_Help_Button({
      mostrar: true,
      title: "Dashboard",
      content: "Dashboard",
    });
    this.imagenNoticia = 'https://daimlertruckmx-academy.com/static/img/noticias/18_1724105465.png';
  },
  watch: {
    buscar: function (value) {
      console.log('DEBUG: value', value);
      if (value.length > 2) {
        this.buscarFn();
      } else if (value.length == 0) {
        this.temas = [...this.temasOriginal];
        this.visibleTemas = this.temas.length > 4 ? this.temas.slice(0, 4) : this.temas;
      }
    }
  },
  computed: {
    cia() {
      return this.$store.getters.getCia;
    },
    menu() {
      return this.$store.getters.getMenu;
    },
    usuario() {
      return this.$store.getters.getUsuario;
    },
  },
};
</script>

<style scoped>
.order-detail-row {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.order-detail-row img{
  height: 90px;
  width: 120px;
  margin-right: 10px;
}
.order-detail-row .name-label{
  margin-right: auto;
}
.no-image {
  height: 90px;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  text-transform: none;
  font-weight: bold;
  margin-right: 1rem;
}
.name-container {
  display: flex;
  flex-direction: column;
  margin-right: auto;
}
.rating-container {
  display: flex;
  align-items: baseline;
}
.rating-container span {
  font-size: 15px;
}
.total-container {
  display: flex;
  align-items: baseline
}
.total-container span{
  font-size: medium;
  font-weight: 900;
  margin-left: .5rem;
  text-transform: none;
}
.btn-color {
  background-color: green;
}
.img-banner {
  max-height: 300px;
  width: 100%;
}

.alert-streaming-info {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  align-items: start;
  gap: 10px;
  margin-top: 10px;
}

.alert-streaming-info .alert-icon {
  font-size: 14px;
  line-height: 1.2;
}

.blocked-pointer {
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/e-commerce/ecommerce-inicio.vue